import { cn } from "@/lib/utils";

const BAR_HEIGHTS = [0.4, 0.7, 0.5, 0.9, 0.6, 1.0, 0.7, 0.5, 0.85, 0.6, 0.75, 0.45, 0.9, 0.65, 0.5];

export function Waveform({ active = false, className }: { active?: boolean; className?: string }) {
  return (
    <div className={cn("flex items-center gap-[3px] h-8", className)}>
      {BAR_HEIGHTS.map((h, i) => (
        <div
          key={i}
          className={cn(
            "rounded-full transition-colors",
            active ? "bg-primary waveform-bar" : "bg-muted-foreground/40",
          )}
          style={{
            width: 3,
            height: `${h * 100}%`,
            animationDelay: `${i * 0.07}s`,
            animationPlayState: active ? "running" : "paused",
          }}
        />
      ))}
    </div>
  );
}

export function StaticWaveform({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-end gap-[3px] h-6 w-32", className)}>
      {BAR_HEIGHTS.map((h, i) => (
        <div
          key={i}
          className="rounded-full bg-current opacity-40"
          style={{ width: 3, height: `${h * 100}%` }}
        />
      ))}
    </div>
  );
}
